module.exports = __webpack_public_path__ + "static/gallery5-6810b0dfdd12f769dac52d38271beca7.jpg";